export function x(d) {
  return d[0];
}

export function y(d) {
  return d[1];
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-voronoi/src/point.js
// module id = WULb
// module chunks = 0